import React from 'react';
import cx from 'classnames';
import redraft from 'redraft';
import { ListingLinkMore } from '@package/components';
import { checkHasContent } from '@package/helpers';
import ViewBlock from './Block/ViewBlock';
import { Container } from 'semantic-ui-react';
import config from '@plone/volto/registry';

const View = ({ data }) => {
  let content = (
    <>
      {(data.title || checkHasContent(data.description)) && (
        <div className="block-content-header">
          {data.title && <div className={cx('title')}>{data.title}</div>}
          {checkHasContent(data.description) && (
            <div className="description">
              {redraft(
                data.description,
                config.settings.richtextViewSettings.ToHTMLRenderers,
                config.settings.richtextViewSettings.ToHTMLOptions,
              )}
            </div>
          )}
        </div>
      )}
      <div className="columns-wrapper">
        {data?.columns?.map((numberBlock, i) => (
          <ViewBlock data={numberBlock} {...data} key={i} />
        ))}
      </div>
      <ListingLinkMore
        linkTitle={data.href_title}
        linkHref={data.href}
        buttonClassName="site--button-primary"
      />
    </>
  );

  const ncolumns = data.n_columns ?? 4;

  return (
    <div
      className={cx('block-icons-text site--preset-wrapper', {
        'multi-rows': data.columns.length > ncolumns,
        ['site--preset-bg-' + data.bg_color]: data.bg_color !== 'transparent',
        'full-width': data.fullWidth,
        'no-adapt-columns': data.noAdaptColumns,
        ['title-' + data.title_color]: data.title_color,
        ['text-' + data.text_color]: data.text_color,
        ['header-align-' + data.header_align]: data.header_align ?? 'center',
        ['columns-' + [ncolumns]]: ncolumns,
        'mobile-block': data.mobileStyles,
      })}
    >
      {data.fullWidth ? <Container>{content}</Container> : content}
    </div>
  );
};

export default View;
